/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var Webcams = /** @class */ (function () {
        function Webcams() {
            this.webcamElms = document.querySelectorAll('img.webcam.live');
            this.base = 'https://www.fjardabyggd.is/fjardabyggd_myndavel/';
        }
        Webcams.prototype.run = function () {
            var _this = this;
            var refresh = function () {
                var cacheBurst = Math.random();
                _this.webcamElms.forEach(function (img) {
                    img.src = "" + _this.base + img.dataset.endpoint + "?timestamp=" + cacheBurst;
                });
            };
            setInterval(refresh, 60000);
        };
        return Webcams;
    }());
    var webcamsExist = function (el) {
        if (!el.querySelector('img.webcam.live')) {
            return;
        }
        var webcams = new Webcams();
        webcams.run();
    };
    webcamsExist(document);

}());
typeof tsBuild === 'function' && tsBuild();})();
